(function($, Drupal, once) {

  Drupal.behaviors.retain_feature_highlights = {
    attach: function (context, settings) {

      $('.feature-highlights').each(function(){
        const parent = $(this);
        const items = parent.find('.feature-highlights-item');

        // Make the first item and screenshot active
        items.first().addClass('active');

        parent.on('click', '.feature-highlights-item', function(e) {
          e.preventDefault();

          const item = $(this);
          items.removeClass('active');
          item.addClass('active');
        });
      });

    }
  }

})(jQuery, Drupal, once)




